export default "__VITE_ASSET__BGV7lTaa__"